export const getMarketingWebsiteUrl = (lang) =>
  lang === "en" ? "https://zory.ai/en" : "https://zory.ai/"
